
import getArea from '../state/get-area';

export default (function (el) {
  return getArea(el.getBoundingClientRect()).center;
});


//////////////////
// WEBPACK FOOTER
// ./~/react-beautiful-dnd/esm/view/get-center-position.js
// module id = 653
// module chunks = 0